import React from 'react';
import { SubscriptionPlan } from '../types/subscription';
import { SUBSCRIPTION_SERVICE } from '../config/subscription';
import './SubscriptionPlanCard.css';

interface SubscriptionPlanCardProps {
  plan: SubscriptionPlan;
  onSubscribe: (plan: SubscriptionPlan) => void;
  isLoading?: boolean;
}

const formatPrice = (price: number): string => {
  if (Number.isInteger(price)) {
    return price.toString();
  }
  return price.toFixed(2);
};

const SubscriptionPlanCard: React.FC<SubscriptionPlanCardProps> = ({
  plan,
  onSubscribe,
  isLoading = false,
}) => {
  const isPopular = plan.badge === 'most-popular';

  return (
    <article className={`plan-card ${isPopular ? 'plan-card--popular' : ''}`}>
      {plan.discountLabel && (
        <span className="plan-badge plan-badge--discount">{plan.discountLabel}</span>
      )}
      {isPopular && (
        <span className="plan-badge plan-badge--popular">Most Popular</span>
      )}

      <div className="plan-card-header">
        <h3 className="plan-name">{plan.description} Pack</h3>
        <p className="plan-duration">{plan.duration}</p>
      </div>

      <div className="plan-pricing">
        <span className="plan-price">
          {SUBSCRIPTION_SERVICE.currency} {formatPrice(plan.price)}
        </span>
      </div>

      <ul className="plan-features">
        {plan.features.map((feature) => (
          <li key={feature} className="plan-feature">
            <span className="plan-feature-icon">✓</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className={`plan-subscribe-btn ${isPopular ? 'plan-subscribe-btn--primary' : ''}`}
        onClick={() => onSubscribe(plan)}
        disabled={isLoading}
      >
        Subscribe
      </button>
    </article>
  );
};

export default SubscriptionPlanCard;
